const Fetcher = require('od-modules/utils/fetcher');
const trackingUtils = require('../utils/tracking.utils');
const logger = require('od-modules/utils/logger');

const composePsd2Metric = (metric, prefix, method) => {
    trackingUtils[method](`FRONT${prefix}${metric}`);
};

const sendLogToKibana = (metric, prefix) => {
    logger.message(`FRONT${prefix}${metric}`);
};

const manageErrors = (paymentHandlerResponse, data) => {
    composePsd2Metric('3DS_TIME_ERROR', '_FLIGHTS_', 'stopMetric');
    logger.message(`Error in recover from user interaction with data - ${JSON.stringify(data)}`);
    paymentHandlerResponse.onBookingError(data);
};

const manageConfirm = (msg, paymentHandlerResponse) => {
    const confirmationData = {
        'bookingstatus': msg.bookingStatus,
        'repricing': msg.repricing,
        'extensions': msg.extensions,
        'myTrip': msg.myTrip,
        'membershipPerksDTO': msg.membershipPerksDTO,
        'userInteractionNeededDTO': msg.userInteractionNeededDTO || null,
        'analyticsEcommerce': msg.analyticsEcommerce,
    };
    paymentHandlerResponse.loadConfirmationUserInteraction(confirmationData);
};

const shouldFirePaymentRetry = (msg) => {
    return msg.bookingStatus === 'BOOKING_PAYMENT_RETRY' && msg.myTrip.paymentRetryInfo.paymentDetails.method !== 'SOFORT';
};

const firePaymentRetry = (msg) => {
    Odigeo.requireWidget('payment-manager', 'paymentmanager', function(widget) {
        const method = Odigeo.SessionScope.flow === 'mobile' ? 'paymentRetryDialog' : 'paymentRetry';
        widget.execute(method, msg);
    });
};

const successHandler = (msg, paymentHandlerResponse) => {
    Odigeo.Session.remove('confirmInteractionNeededData');
    logger.message(`Recover from user interaction response with data - ${JSON.stringify(msg)}`);
    if (Odigeo._.isEmpty(msg) || msg.errors) {
        manageErrors(paymentHandlerResponse, msg);
    } else if (shouldFirePaymentRetry(msg)) {
        firePaymentRetry(msg);
    } else {
        manageConfirm(msg, paymentHandlerResponse);
    }
};

const createIframeWithData = (data, iframe = true, bookingId = '') => {
    const $params = Odigeo._.map(data.parameters, function(value, param) {
        return $('<input>', {
            value: value,
            name: param,
        });
    });

    const defaultOptions = {
        method: data.sendType,
        action: data.redirectUrl,
    };

    const msg = `Opening bank page AFTER JAVASCRIPTSNIPPET with parameters with bookingId ${bookingId} and params ${JSON.stringify({
        data,
        defaultOptions,
        $params,
    })}`;
    logger.error({data, defaultOptions, $params}, msg);
    $('<form>', Object.assign({}, defaultOptions, iframe ? {target: 'iframeUserInteractionNeeded'} : {}))
        .append($params)
        .appendTo($('body'))
        .submit();
};

const showLoadingAndIframe = (bookingId) => {
    return Fetcher.get(Odigeo.Settings.property('appContext') + '/service/recoverfromuserinteraction').json()
        .then((data) => {
            logger.error(data, `Recovered userInteraction from psd2 with bookingId ${bookingId} and data ${JSON.stringify(data)}`);
            Odigeo.Session.set('confirmInteractionNeededData', JSON.stringify(data.userInteractionNeededDTO));
            createIframeWithData(data.userInteractionNeededDTO, true, bookingId);
        });
};

const recoverFromUserInteraction = (paymentHandlerResponse) => {
    return Fetcher.get(Odigeo.Settings.property('appContext') + '/service/recoverfromuserinteraction').json()
        .then(Odigeo._.partial(successHandler, _, paymentHandlerResponse))
        .catch(() => manageErrors(paymentHandlerResponse));
};

const initHandler = (paymentHandlerResponse) => {
    window.addEventListener('message', Odigeo._.partial(receiveMessage, _, paymentHandlerResponse), false);
};

const checkPayment3dsStatus = (event, status) => {
    return event.data && event.data.payment3ds === status;
};

const receiveMessage = (event, paymentHandlerResponse) => {
    const bookingId = event.data && event.data.bookingId && parseInt(event.data.bookingId, 10);
    if (checkPayment3dsStatus(event, 'OK')) {
        unblockScroll();
        recoverFromUserInteraction(paymentHandlerResponse);
    } else if (checkPayment3dsStatus(event, 'KO')) {
        if (Odigeo.SessionScope.flow === 'mobile') {
            paymentHandlerResponse.toggleIframeFullPage(false);
        }
        Fetcher.get(Odigeo.Settings.property('appContext') + '/service/recoverfromuserinteraction').json()
            .then((response) => {
                const [message] = response && response.flowErrors && Object.values(response.flowErrors) || [];
                manageErrors(paymentHandlerResponse, response);
                if (message && message.errorMessageKey) {
                    trackingUtils.trackEventWithCategory('flights_pay_page', 'payment_details_error', message.errorMessageKey);
                }
            })
            .catch((response) => logger.error('Error in recover', response));
        unblockScroll();
    } else if (checkPayment3dsStatus(event, 'LOADING')) {
        logger.error(event, `Loading iframe psd2 with bookingId ${bookingId}`);
        showLoadingAndIframe(bookingId);
    }
};

const unblockScroll = () => {
    $('body').removeClass('odf-overflow-hidden');
};

export default {
    recoverFromUserInteraction,
    initHandler,
    composePsd2Metric,
    sendLogToKibana,
    createIframeWithData,
};
